import React from "react";
import {
  creditHistoryConnector,
  withUserCreditHistory,
} from "../../../../services/creditHistory/connector";
import { compose } from "redux";
import { Card, CardActionArea, CardContent } from "@material-ui/core";
import { boolRenderer } from "../CreditApplicationDetails/CreditOffersCmps/helper";

const AppListComponent = ({ app }) => {
  return (
    <ul style={{ listStyleType: "none" }}>
      <li key={app.accountId}>
        <strong>Id:</strong> {app.Id}
        <br />
        <strong>Amount:</strong> {app.AppliedAmount.Amount}
        <br />
        <strong>Submitted:</strong> {app.DateSubmitted}
        <br />
        <strong>Stage:</strong>{" "}
        {app.Stage === "ManuallyRejected" ? (
          <span style={{ color: "red", fontWeight: "bold" }}>{app.Stage}!</span>
        ) : (
          app.Stage
        )}
        <hr />
      </li>
    </ul>
  );
};

const LoanListComponent = ({ loan }) => {
  return (
    <ul style={{ listStyleType: "none" }}>
      <li key={loan.accountId}>
        <strong>Id:</strong> {loan.Id} <br />
        <strong>Amount:</strong> {loan.Amount.Amount} <br />
        <strong>Created:</strong> {loan.Created} <br />
        <strong>Paid out:</strong>{" "}
        {loan.PaidOut ? loan.PaidOut : <span>not payed out</span>} <br />
        <strong>Credit stage:</strong>
        {loan.CreditStage !== "FullyPaid" ? (
          <span style={{ color: "red", fontWeight: "bold" }}>
            {loan.CreditStage}!
          </span>
        ) : (
          loan.CreditStage
        )}
        <hr />
      </li>
    </ul>
  );
};

const CreditAppListComponent = ({ app }) => {
  return (
    <ul style={{ listStyleType: "none" }}>
      <li key={app.BorrowerId}>
        <div>
          <strong>Id:</strong> {app.Id}
        </div>
        {app.CreditOffers.map((offer) => (
          <div
            style={{ margin: "10px 5px", display: "inline-block" }}
            key={offer.Id}
          >
            <div>
              <strong>Payout Amount:</strong>
              {offer.PayoutAmount}
            </div>
            <div>
              <strong>Offer decision:</strong>
              {offer.CreditDecision}
            </div>
            <div>
              <strong>Is signed:</strong>
              {boolRenderer(offer.IsSigned)}
            </div>
          </div>
        ))}
        <div>
          <strong>Submitted:</strong> {app.SubmittedAt}
        </div>
        <div>
          <strong>User info finalized at:</strong> {app.UserInfoFinalizedAt}
        </div>
        <div>
          <strong>Evaluated at:</strong> {app.EvaluatedAt}
        </div>
        <div>
          <strong>Decline reason:</strong>{" "}
          {app.DeclineReason === null ? (
            "Not Declined"
          ) : (
            <span style={{ color: "red", fontWeight: "bold" }}>
              {app.DeclineReason}
            </span>
          )}
        </div>
        <hr />
      </li>
    </ul>
  );
};

const CreditHistory = (props) => {
  let loanList = props.userLoans.map((loan) => {
    return <LoanListComponent key={loan.Id} loan={loan} />;
  });

  let applicationList = props.userApplications.map((app) => {
    return <AppListComponent key={app.Id} app={app} />;
  });

  let creditApplicationList = props.userCreditApplications.map((app) => {
    return <CreditAppListComponent key={app.Id} app={app} />;
  });

  return (
    <React.Fragment>
      <div style={{ marginTop: "50px", marginBottom: "15px", height: "200px" }}>
        <div
          style={{
            float: "left",
            marginLeft: "40px",
            marginRight: "20px",
            minWidth: "500px",
          }}
        >
          <Card style={{ minHeight: "150px" }}>
            <CardActionArea>
              <CardContent>
                <h2>Total amount of loans: {props.userLoans.length}</h2>
                {loanList}
              </CardContent>
            </CardActionArea>
          </Card>
        </div>
        <div
          style={{
            float: "left",
            marginLeft: "40px",
            marginRight: "20px",
            minWidth: "500px",
          }}
        >
          <Card style={{ minHeight: "150px" }}>
            <CardActionArea>
              <CardContent>
                <h2>
                  Total amount of applications:{" "}
                  {props.userApplications.length +
                    props.userCreditApplications.length}
                </h2>
                {applicationList}
                {creditApplicationList}
              </CardContent>
            </CardActionArea>
          </Card>
        </div>
      </div>
    </React.Fragment>
  );
};

export default compose(
  creditHistoryConnector,
  withUserCreditHistory,
)(CreditHistory);
